import request, { download } from "@/utils/request";

//课程归属
export function getCourseListApi(data) {
  return request({
    url: `/system/practical/courseStarts/classroomDisplayList`,
    method: "post",
    data,
  });
}

//获取我的成绩
export function getMyScoreApi(params) {
  return request({
    url: `/system/practical/learning/task/getMyScore`,
    method: "get",
    params,
  });
}

// 查询需求列表
export async function demandQuery(params = {}) {
  return await request({
    url: `/system/demand/query`,
    method: "get",
    params,
  });
}

// 置顶需求
export async function demandPinTop(data = {}) {
  return await request({
    url: `/system/demand/pinTop`,
    method: "put",
    data,
  });
}

// 初始化需求
export async function demandInit(data = {}) {
  return await request({
    url: `/system/demand/init`,
    method: "put",
    data,
  });
}

// 更新需求
export async function demandUpdate(data = {}) {
  return await request({
    url: `/system/demand/update`,
    method: "put",
    data,
  });
}

// 删除需求
export async function demandDelete(data = {}) {
  return await request({
    url: `/system/demand/delete`,
    method: "delete",
    data,
  });
}

// 创建需求
export async function demandCreate(data = {}) {
  return await request({
    url: `/system/demand/create`,
    method: "post",
    data,
  });
}

// 查询班级信息
export async function demandClassConfigQuery(params = {}) {
  return await request({
    url: `/system/demand-class-config/query`,
    method: "get",
    params,
  });
}

// 课堂互动开关
export async function demandClassConfig(data = {}) {
  return await request({
    url: `/system/demand-class-config/config`,
    method: "post",
    data,
  });
}

// 查询参与人数问题数量投票人数
export async function demandSummary(params = {}) {
  return await request({
    url: `/system/demand/summary`,
    method: "get",
    params,
  });
}

// 移动需求排序
export async function demandMoveSort(data = {}) {
  return await request({
    url: `/system/demand/move-sort`,
    method: "put",
    data,
  });
}

// 查询需求收藏列表
export async function demandCollectionQuery(params = {}) {
  return await request({
    url: `/system/demand-collection/query`,
    method: "get",
    params,
  });
}

// 根据班级id课次获取课节
export async function getClassTimesVos(params = {}) {
  return await request({
    url: `/system/practical/learning/task/getClassTimesVos`,
    method: "get",
    params,
  });
}

// 获取学习任务
export async function getLearningTask(params = {}) {
  return await request({
    url: `/system/practical/learning/task/getLearningTask`,
    method: "get",
    params,
  });
}

// 开始考试
export async function beginExam(params = {}) {
  return await request({
    url: `/system/practical/learning/task/beginExam`,
    method: "post",
    params,
  });
}


//查看作业详情
export async function getExamStudentReport(id) {
  return await request({
    url: `/system/practical/learning/task/examReport?examStudentInfoId=${id}`,
    method: "post",
  });
}

// 批量提交考试答案
export async function batchSubmitQuestion(data = []) {
  return await request({
    url: `/system/practical/learning/task/batchSubmitQuestion`,
    method: "post",
    data,
  });
}

// 结束考试
export async function endExam(data = {}) {
  return await request({
    url: `/system/exam/endExam`,
    method: "post",
    data,
  });
}

// 需求问题详情
export async function demandCollectionDetail(params = {}) {
  return await request({
    url: `/system/demand-collection/detail`,
    method: "get",
    params,
  });
}

// 需求问题回复
export async function demandReplySonCreate(data = {}) {
  return await request({
    url: `/system/newschool/demand-reply-son/create`,
    method: "post",
    data,
  });
}

// 投票收集
export async function demandCollectionCreate(data = {}) {
  return await request({
    url: `/system/demand-collection/create`,
    method: "post",
    data,
  });
}

// 点共鸣/取消共鸣
export async function demandCollectionLike(data = {}) {
  return await request({
    url: `/system/demand-collection/like`,
    method: "put",
    data,
  });
}
